import ComposerRefinementPreview from './ComposerRefinementPreview'
import ComposerReplyPreview from './ComposerReplyPreview'

export default function AiAskBarContextPreviews({ replyPreview, replySnippet, onDismissReplyPreview, refinementText, onDismissRefinement }) {
  return (
    <>
      {replyPreview ? <ComposerReplyPreview authorName={replyPreview.authorName} createdAt={replyPreview.createdAt} snippet={replySnippet} onDismiss={onDismissReplyPreview ?? (() => {})} /> : null}
      {refinementText ? <ComposerRefinementPreview text={refinementText} onDismiss={onDismissRefinement} /> : null}
    </>
  )
}
